(function () {
  'use strict';

  /* @ngdoc object
   * @name myMemberships.import
   * @description
   *
   */
  angular
    .module('myMemberships.import', [
      'ui.router'
    ]);
}());
